import { PatientCreate } from "@/types/patient";

const NAME_PATTERN = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;
const PHONE_PATTERN = /^\+?[\d\s().-]+$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function parsePatientNameFromSearch(
  search: string,
): { firstName: string; lastName?: string } | null {
  const trimmed = search.trim();
  if (!trimmed || !NAME_PATTERN.test(trimmed)) return null;
  const parts = trimmed.split(/\s+/);
  if (parts.length > 3) return null;
  const firstName = parts[0];
  const lastName = parts.slice(1).join(" ") || undefined;
  return { firstName, lastName };
}

/** Maps a patient-search term to the create-patient field it most likely is. */
export function patientPrefillFromSearch(
  search: string,
): Partial<PatientCreate> | undefined {
  const trimmed = search.trim();

  const name = parsePatientNameFromSearch(trimmed);
  if (name) {
    return {
      firstName: name.firstName,
      ...(name.lastName ? { lastName: name.lastName } : {}),
    };
  }

  if (EMAIL_PATTERN.test(trimmed)) return { email: trimmed };

  if (PHONE_PATTERN.test(trimmed)) {
    const digits = trimmed.replace(/\D/g, "");
    if (digits.length === 10) return { phoneNumber: digits };
    if (digits.length === 11 && digits.startsWith("1")) {
      return { phoneNumber: digits.slice(1) };
    }
  }

  return undefined;
}
